export default function SkeletonRow({ count = 6, aspect = "aspect-video", width = "w-[320px]" }) {
    return (
        <div className="flex gap-4 px-6 lg:px-10 pb-4">
            {Array.from({ length: count }).map((_, i) => (
                <div key={`skeleton-${aspect}-${i}`} className={`shrink-0 ${width} ${aspect} rounded-[18px] bg-white/5 animate-pulse`} />
            ))}
        </div>
    );
}
